import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getForecastHistoryTableSlice = createApi(`ForecastHistoryTableSlice`,"GET");

const ForecastHistoryTableSlice = createSlice({
  name: 'ForecastHistoryTableSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getForecastHistoryTableSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getForecastHistoryTableSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getForecastHistoryTableSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default ForecastHistoryTableSlice.reducer;